import { Flex } from "@chakra-ui/react";
import { Button, Modal } from "barte-design-system";

interface FormModalProps {
  isOpen: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  handleConfirmModal: () => void;
  children?: React.ReactNode;
  title: string;
  confirmationButtonText?: string;
  disableWhenIsFormEmpty?: boolean;
  variant?: string;
}

const FormModal: React.FC<FormModalProps> = ({
  isOpen,
  isSubmitting,
  onClose,
  handleConfirmModal,
  children,
  title,
  confirmationButtonText = "Adicionar",
  disableWhenIsFormEmpty = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      className="modal-viewport-capped"
      footer={{
        primaryButton: {
          id: confirmationButtonText === "Adicionar" ? "recebimento_manual" : undefined,
          children: confirmationButtonText,
          type: "submit",
          disabled: isSubmitting || disableWhenIsFormEmpty,
          onClick: (e) => {
            e.preventDefault();
            handleConfirmModal();
          },
        },
        secondaryButton: {
          children: "Cancelar",
          type: "button",
          variant: "outline",
          onClick: onClose,
        },
      }}
    >
      {children}
    </Modal>
  );
};

export { FormModal }
